import { atom } from "recoil";
import { NewRequisitionType } from "../components/NewRequisition/types";
import { getInitialNewRequisitionForm } from "./helpers";
import {
  UserProviderProfile,
  UserAuthProviderResponse,
  UserDefaultRequisitionsResponse,
  UserSearchRequisitionsResponse,
  MissingRequisitionResponse,
  NewRequisitionForm,
  NewRequisitionFormEdit,
  NotificationFrequencyResponse,
} from "./types";

// const getDefaultData = () => {
//   if (import.meta.env..VITE_ENV === "local") {
//     return testDefaultData; // can be set to defaultData if testing of dummy data is needed
//   }
//   return testDefaultData;
// };

export const defaultRequisitions = atom<
  UserDefaultRequisitionsResponse | undefined
>({
  key: "defaultRequisitions",
  default: undefined,
});

export const searchRequisitions = atom<
  UserSearchRequisitionsResponse | undefined
>({
  key: "searchRequisitions",
  default: undefined,
});

export const providerState = atom<UserAuthProviderResponse | undefined>({
  key: "providerState",
  default: undefined,
});

export const providerProfileState = atom<UserProviderProfile | undefined>({
  key: "providerProfileState",
  default: undefined,
});

export const providerEmailNotificationFrequency = atom<
  NotificationFrequencyResponse | undefined
>({
  key: "providerEmailNotifications",
  default: undefined,
});

export const resetPwEmail = atom<string | undefined>({
  key: "resetPwEmail",
  default: undefined,
});

export const gridSearchText = atom<string>({
  key: "searchText",
  default: "",
});

export const missingRequisitions = atom<MissingRequisitionResponse[]>({
  key: "missingRequisitions",
  default: [],
});

export const currentNewRequisition = atom<NewRequisitionForm>({
  key: "newRequisition",
  default: getInitialNewRequisitionForm(),
});

export const currentEditDraftRequisition = atom<NewRequisitionType | undefined>(
  {
    key: "currentEditDraftRequisition",
    default: undefined,
  },
);

export const currentNewRequisitionEdit = atom<NewRequisitionFormEdit>({
  key: "newRequisitionEdit",
  default: {
    preflight: false,
    isError: false,
    isDraftError: false,
    requisitionForm: getInitialNewRequisitionForm(),
  },
});

export const orderedRequisitions = atom<NewRequisitionType[]>({
  key: "orderedRequisitions",
  default: [],
});

export const defaultReqsRequestComplete = atom<boolean>({
  key: "defaultReqsRequestComplete",
  default: false,
});

export const orderedReqsRequestComplete = atom<boolean>({
  key: "orderedReqsRequestComplete",
  default: false,
});

export const loggedOutDueToInactivity = atom<boolean>({
  key: "loggedOutDueToInactivity",
  default: false,
});
